'use client'

import AuthRedirect from 'containers/AuthRedirect'
import FooterPortal from 'containers/Layouts/Layout/FooterPortal'
import RegisterContainer from 'pageContainers/RegisterPage'

export default function Register(props: { cookie: string }) {
  return (
    <>
      <AuthRedirect />
      <RegisterContainer cookie={props.cookie} />
      <FooterPortal />
    </>
  )
}
